import type { HTMLAttributes, ReactNode } from "react";
import { useMemo } from "react";
import React from "react";
import type { CKFilterContextProps } from "./CKFilterContext";
import { useCKFilterContext } from "./CKFilterContext";

export interface CKFilterItemProps<T = any> extends Omit<HTMLAttributes<HTMLElement>, "children"> {
  value: T;
  children(props: { selected: boolean; onUpdate: CKFilterContextProps<T>["onUpdate"] }): ReactNode;
  as?: React.ElementType;
}

export const CKFilterItem = <T extends any>({ as = "li", value, children, ...restProps }: CKFilterItemProps<T>) => {
  const { ifChecked, onUpdate } = useCKFilterContext<T>();
  const selected = useMemo(() => ifChecked(value), [ifChecked, value]);

  return React.createElement(as, restProps, children({ selected, onUpdate: onUpdate }));
};
